var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 120.004 359.579",
    width: 167.705,
    height: 304.636,
    className: "illustration styles_illustrationTablet__1DWOa",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 99.57,
    y1: 139.41,
    x2: 288.05,
    y2: 139.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 137.19,
    y1: 173.66,
    x2: 272.37,
    y2: 119.11,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 243.3,
    y1: 63.95,
    x2: 242.74,
    y2: 14.57,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 210.04,
    y1: 61.26,
    x2: 206.17,
    y2: 62.39,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 255.93,
    y1: 58.71,
    x2: 270.31,
    y2: 58.71,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 187.46,
    y1: 126.7,
    x2: 220.89,
    y2: 135.26,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 211.55,
    y1: 143.84,
    x2: 261.24,
    y2: 156.57,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 262.97,
    y1: 159.92,
    x2: 262.97,
    y2: 159.92,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 246.46,
    y1: 121.3,
    x2: 275.89,
    y2: 121.3,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 227.82,
    y1: 157.45,
    x2: 241.81,
    y2: 304.33,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 158.61,
    y1: 251.48,
    x2: 240.86,
    y2: 230.51,
    gradientTransform: "translate(-90.885 55.621)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 322.79,
    y1: 341.99,
    x2: 256.88,
    y2: 346.39,
    gradientTransform: "translate(-161.395 -30.469)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 184.35,
    y1: 45.11,
    x2: 200.79,
    y2: 156.7,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 230.39,
    y1: 56.76,
    x2: 183.72,
    y2: 60.87,
    xlinkHref: "#a",
    gradientTransform: "translate(-137.195 -3.369)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 99.57,
    y1: 139.41,
    x2: 288.05,
    y2: 139.41,
    gradientTransform: "translate(-137.195 -3.369)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.895 86.521c-.23 9.33-1 18.67-3.42 27.63-.33 1.2-.68 2.39-1.06 3.56-9.61 30.14-35.55 51.86-49.61 80.26a109.71 109.71 0 0 0-7.52 19.77 1.35 1.35 0 0 0-.09.33 113 113 0 0 0-4 27.44 8.05 8.05 0 0 1-1 .17c-7 1.1-13.88-3.25-19.26-8.18-5.63-5.17-10.74-11.36-17.67-14.26-10-4.17-21.68-.73-31.69-4.81-12.28-5-18.3-20-18.7-33.81-.2-6.84.47-14.31-3.34-19.81-2.83-4.08-7.49-6.15-11.57-8.81-12.25-8.07-19.72-23-20.55-38.09a59.44 59.44 0 0 1 1.92-18.28 69.18 69.18 0 0 1 11.59-23.89c3.4-4.52 7.32-8.65 10-13.68a19.79 19.79 0 0 0 1.36-3c1.69-4.37 2.18-9.29.33-13.51-1-2.2-2.58-4.3-2.7-6.7a2.06 2.06 0 0 1 0-.36c0-3.74 3.61-6.22 6.78-7.91 12.23-6.46 27-11.66 39.16-5.11 7.6 4.1 12.87 12.24 20.81 15.63a33.19 33.19 0 0 0 7.64 2c2.16.36 4.33.67 6.47 1.16 7.95 1.79 12.25 6.31 18.27 10.66.51.37 1 .75 1.58 1.11 6.42 4.34 18.5 1.94 25.23-.58 6.46-2.39 12.39-7.09 19.24-7.24 8-.2 15.08 6.12 18.43 13.7 3.35 7.58 3.59 16.25 3.37 24.61z",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.805 90.281c-.24 9.25-1 18.53-3.39 27.43 0 .07 0 .13-.05.2-8.61 32-36.06 54.32-50.68 83.82a110 110 0 0 0-6.42 16 2.23 2.23 0 0 0-.09.32 112.81 112.81 0 0 0-4.93 27.61c-7 1.1-13.86-3.25-19.26-8.18-5.61-5.18-10.73-11.35-17.67-14.26-10-4.17-21.67-.72-31.68-4.81-12.28-5-18.31-20-18.7-33.82-.19-6.82.48-14.3-3.35-19.8-2.82-4.09-7.49-6.14-11.55-8.82-12.25-8.07-19.73-23-20.57-38.08a59.15 59.15 0 0 1 1.88-18.26 68.94 68.94 0 0 1 10.46-20.13c3.39-4.51 7.3-8.65 10-13.67a24.76 24.76 0 0 0 2.44-6.75 16.21 16.21 0 0 0-.77-9.75c-1-2.33-2.74-4.5-2.72-7.06a6 6 0 0 1 1.12-3.4 15.39 15.39 0 0 1 5.66-4.53c12.22-6.44 27-11.64 39.16-5.09 7.61 4.1 12.86 12.24 20.81 15.62 4.46 1.9 9.4 2.08 14.1 3.16 8.63 2 13 7.11 19.85 11.77 6.42 4.34 18.5 2 25.23-.58 6.46-2.41 12.39-7.09 19.24-7.25 8-.18 15.08 6.14 18.44 13.72 3.36 7.58 3.65 16.23 3.44 24.59z",
    fill: "url(#a)",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.025 75.861c-8.85-4-18.77-4.34-28.41-4.62-2.33-.06-4.76-.1-6.84 1a14.26 14.26 0 0 0-4.16 3.93c-10.1 12.54-20.08 27.09-19.57 43.5a11.38 11.38 0 0 0 .88 4.57c1 2 2.8 3.28 4.61 4.44a102.19 102.19 0 0 0 71.57 14.81c13.35-2.24 26.39-7.19 39.91-7-.38 9.68-9.89 15.86-18.52 19.33a135 135 0 0 1-56.15 9.64l-3.88 41.36 77.34-27.55a112.45 112.45 0 0 0-9.52 59.91c.18 1.51.48 3.2 1.67 4.07 1.19.87 2.87.58 4.33.23 9.77-2.38 20.17-5.11 27-12.85 4-4.53 6.32-10.38 7.87-16.3 3.65-14 3.3-28.78 6.6-42.84 3.13-13.33 9.44-25.61 13-38.83 6.77-25.33-5.14-56-34.41-52.16-12.54 1.63-23.87 10.18-36.45 11.48-14.67 1.52-24.37-10.47-36.87-16.12z",
    fill: "url(#c)",
    style: {
      fill: "url(#c)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.215 144.991c-1.29 9.58-4.25 18.82-7.48 27.89-.55 1.57-1.2 3.25-2.58 4.11-2 1.27-4.74.15-6.13-1.8-1.39-1.95-1.76-4.5-2-6.92a125.07 125.07 0 0 1 2.86-42.47 7.59 7.59 0 0 0 .31-3.68 8.65 8.65 0 0 0-2.08-3.18 19.88 19.88 0 0 1-4.38-10.66c-5.7 5.64-11.62 11.67-13.86 19.54-2.69 9.57.6 19.68 2.58 29.45 6.18 30.38-.5 62.63 7.08 92.66 2.07 8.21 4.53 34.26 3.62 34.64-4.43 1.8-7.07 4-11.79 4.51a4.89 4.89 0 0 1-3-.3c-1.26-.71-2.46-5.88-2.81-7.31-1.69-7-17-49.27-12.14-40.22 7.9 14.82 8.22 44.26 8.22 46.26 0 3.05-19.05 3.32-21.81.83-2.76-2.49-5.35-36-6.42-39.94-1.07-3.94-1.78-8.79-3.76-12.36-9.3-16.79-14.32-36.8-12.34-56.1q.78-7.59 1.57-15.17c.79-7.73 1.57-15.75-.79-23.13-1-3.06-2.46-10.48-2.46-10.76a104.19 104.19 0 0 0-11.61 31.56 4.39 4.39 0 0 1-1.11 2.63 2 2 0 0 1-.77.46 5.87 5.87 0 0 1-1.83.25l-8.23.27c-2.62-20.6 2.7-41.33 8.77-61.09a108 108 0 0 0 4.1-16c.74-5 .75-10.15 2.34-14.9 3.36-10 11.26-13.82 20.58-14.19a305.27 305.27 0 0 0 35-3.51c4.81-.76 9.66-1.64 14.47-1 9.65 1.25 17.95 8.6 22.32 17.68 5.33 11.07 3.31 21.7 4.41 33.35 1.24 12.89 2.91 25.62 1.15 38.6z",
    fill: "#68e1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.235 181.081c-.38 2-1 4-.51 6 .61 2.77 3 4.63 5.32 6.14a9.22 9.22 0 0 0 3.21 1.53c2.33.45 4.71-1 6.19-2.89a21.31 21.31 0 0 0 3-6.74 6.92 6.92 0 0 0 .47-3c-.31-2.2-2.53-3.46-3.74-5.29-2.13-3.24-.85-7.7-1.76-11.52a2.66 2.66 0 0 0-.7-1.42 2.82 2.82 0 0 0-1.75-.52c-3.51-.21-8.42-1-9.23 3.5-.81 4.5.39 9.51-.5 14.21zM133.325 181.401c-1.35 1.12-2.91 1.95-4.23 3.12a6.34 6.34 0 0 0-2.42 4.59 16.21 16.21 0 0 0 1 3.89c.62 2.34.4 5 1.83 6.95 1.84 2.45 5.46 2.32 8.26 1.26 4.19-1.6 8-5.18 8.62-9.8.27-1.95 0-3.95.22-5.9.31-2.35 1.44-4.5 2.07-6.78 1.22-4.45-2.13-10.94-7.33-8.6-1.9.85-2.5 3.42-3.39 5.16a18.83 18.83 0 0 1-4.63 6.11zM117.805 47.851c1.49 1.34 3.47 1.89 5.31 2.62a26 26 0 0 1 6.88 4 1.52 1.52 0 0 1 .63.85c.13.73-.72 1.19-1.4 1.39a166.06 166.06 0 0 1-21.15 4.38c-10 1.58-20.45 3-30.06-.37-.44-.16-1-.48-.87-1a1 1 0 0 1 .35-.49 23.24 23.24 0 0 1 5.5-3.25c2.54-1.25 7-1.88 9.18-3.76 5.85-5.11 2.15-15 2.56-15.66 1.18-2 3.62-2.68 5.84-3a20 20 0 0 1 8.11.44c2.3.67 6 2.35 6.29 5.12.22 3.28.25 6.45 2.83 8.73z",
    fill: "#f6ad82"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.435 42.891c1.33 2.64 2.93 5.35 5.5 6.64 2.29 1.14 5 1 7.45.47a4.67 4.67 0 0 0 3.09-1.54 5.49 5.49 0 0 0 .66-3.22v-9.08c-3.67.86-7.42 1.72-11.17 1.4-1.5-.13-5.85-1.5-7-.15-1.15 1.35.84 4.27 1.47 5.48z",
    fill: "url(#d)",
    style: {
      fill: "url(#d)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.115 27.631c.35.68.9 1.25 1.2 2 .3.75.32 1.4.6 2.06.28.66.95 1.23 1.6 1a12.28 12.28 0 0 0 2.42 7.25 9.36 9.36 0 0 0 6.37 3.66c2.36.22 4.68-.58 6.93-1.37l4.85-1.7a3.37 3.37 0 0 0 1.31-.69 3.74 3.74 0 0 0 .81-2.21l.83-5.27a1.45 1.45 0 0 1 .23-.68 1.84 1.84 0 0 1 .85-.45c1.25-.48 1.87-1.94 2.2-3.29a3.58 3.58 0 0 0-.16-2.79c-.53-.8-1.93-.89-2.23 0a23.88 23.88 0 0 0-1.71-10.07 11.66 11.66 0 0 0-7.1-6.66 15.09 15.09 0 0 0-6.1-.08 14 14 0 0 0-4.09 1.08c-1.29.62-3.38-1-4 .37a35.93 35.93 0 0 0-2 4.23c-.24 1.7-.21 5.17-.46 6.88-.18 1.25 2 3.09 1.32 4.1-.68 1.01-5.55-1-3.67 2.63z",
    fill: "#f6ad82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.515 23.461a59.73 59.73 0 0 1-.6-8.87 10.59 10.59 0 0 1 .81-4.69 10.88 10.88 0 0 1 3.17-3.38l2.63-2.09a22.63 22.63 0 0 1 6.11-3.87 7.36 7.36 0 0 1 6.88.66c1.95 1.46 2.91 4.13 5 5.35.63.36 1.35.58 2 1a5.86 5.86 0 0 1 2.38 3.38 15.06 15.06 0 0 1 .49 4.24q0 3.09-.24 6.15c-.18 2-.74 4.33-2.54 5l-.26-3.32a30.29 30.29 0 0 0-1-6.65 9.78 9.78 0 0 0-3.68-5.36 5.34 5.34 0 0 0-5.53-.37 1.34 1.34 0 0 0-.6.6 2.36 2.36 0 0 0-.06.84 3.41 3.41 0 0 1-1.91 3.14 3.14 3.14 0 0 1-3.49-.7c-.46-.49-.61-1.54 0-1.65a1.84 1.84 0 0 0 2.49.95 2.3 2.3 0 0 0 1-2.67 2.5 2.5 0 0 0-2.31-1.65 5.1 5.1 0 0 0-2.47.91l-3.06 1.78a6 6 0 0 0-1.5 1.1c-1 1.15-1 2.9-1 4.48l.08 4.29c0 .94.44 3 0 3.82-1.06 2.02-2.65-1.43-2.79-2.42z",
    fill: "#404040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.395 55.491a12.41 12.41 0 0 0 2.06 4.14c.83 1.08 1.89 2.13 2 3.52a.88.88 0 0 1-.08.53.84.84 0 0 1-.74.31 3.14 3.14 0 0 1-2.1-.78c.19.58-.54 1-1.12 1-2.7.13-4.9-2.27-7.52-3a14.72 14.72 0 0 1-2.37-.61 7.2 7.2 0 0 1-2.3-2l-2.08-2.43a1.53 1.53 0 0 1-.41-.69c-.15-.75.68-1.3 1.39-1.47 1.6-.4-3-5.08-.72-5.28 1.56-.14 10.58 3.82 11.91 4.69.66.43 1.18 1.05 1.81 1.53a2.54 2.54 0 0 0 2.16.63",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.805 56.681c-.46 2.14 0 4.53-1 6.44.37.1.72-.18 1-.44a12.42 12.42 0 0 1 5-2.65 5 5 0 0 1-2.15-1.92 8.27 8.27 0 0 1-1.85-3.17c-.64.26-.9 1.1-1 1.74z",
    fill: "url(#e)",
    style: {
      fill: "url(#e)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.315 55.631c.11.37-.94.92-1.1 1.27-.31.72-1.24.77-2 .84-2.88.26-5.31 2.26-7.59 4.13-.64.52-1.5 1.07-2.21.65a1.57 1.57 0 0 1-.69-1.1 6.27 6.27 0 0 1 .93-4c1-2 3.22-7.21 3.64-7.3a8.94 8.94 0 0 1 3.92.14c1.07.48.56.57.69 1.52.13.95.94 1.15 1.7 1.7s2.44 1.15 2.71 2.15z",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.105 52.121q-1.68 3.38-3.14 6.87c-.2.48-.38 1.1 0 1.49.38.39 1.05.2 1.55-.07q2.43-1.29 4.76-2.78a2.45 2.45 0 0 0 1-1c.41-.91-.3-2 0-3a2.43 2.43 0 0 1 1.56-1.44 10.18 10.18 0 0 1 5.37-.31 6.68 6.68 0 0 0-5-2c-1.33.07-2.61.47-3.94.49-1.21.11-1.63.69-2.16 1.75z",
    fill: "url(#f)",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.595 130.881a99.28 99.28 0 0 0-11.27 30.84 4.41 4.41 0 0 1-1.1 2.63 2.15 2.15 0 0 1-.78.46 3.26 3.26 0 0 1-2.17-1.27c-1.08-1.5-.79-3.61-.45-5.45q3.1-16.17 7-32.13a22 22 0 0 1 1.71-5.16 20.33 20.33 0 0 0 1-2 10.27 10.27 0 0 0 .27-4.17 92.55 92.55 0 0 1 2.73-27.55c.34 4.93.67 9.88 1.48 14.73.84 5.15 2.19 10.19 2.74 15.37.55 5.18-1.16 13.98-1.16 13.7z",
    fill: "url(#g)",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.185 145.051s12.05-.72 21.33-1.45c9.28-.73 17.85-.49 22-.73a50.42 50.42 0 0 0 6.5-.73l1.85 7.78s-9.74 1.21-12.52 1.21c-2.78 0-36.17 2.43-39.42-.49z",
    fill: "url(#h)",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.495 92.681c-2.53 4.21-5.1 8.47-8.55 11.88-3.45 3.41-7.94 5.95-12.68 5.95 2.34.42 3.2 3.56 2.84 6-.36 2.44-1.43 4.89-1 7.33a36.12 36.12 0 0 0 1.5 4.11c1.16 3.65-.11 7.63.12 11.46a3.47 3.47 0 0 0 .61 2 3.62 3.62 0 0 0 2.33 1l3.86.61a3.62 3.62 0 0 0 2.26-.13 3.79 3.79 0 0 0 1.12-1.1l9.25-11.89a37.12 37.12 0 0 0 4.85-7.27c2.07-4.59 2.47-10.29-.11-14.68-2.86-4.87-4.54-9.89-6.4-15.27z",
    fill: "url(#j)",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.035 263.681s-14-38.34-16.22-52c-2.22-13.66-2.86-27.33-2.86-27.33s-5.72-9-6.36-13.67c-.64-4.67-4.13 20.67-4.13 20.67s17.49 47.34 17.49 55.67c0 8.33 7 42 7 42s6.72.65 7.65-1.51c.93-2.16-2.57-23.83-2.57-23.83z",
    fill: "url(#k)",
    style: {
      fill: "url(#k)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m114.265 264.871-19.69-4.45s-4.36 5.93-7 3.22l5.89 32.66 3.07 31.07-5.62 26.26s-2.19 7.79 5.07 5.54 13.57-14.4 15.43-17.54l4.84-6.65-3.17-17.11z",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.265 264.871-19.69-4.45s-4.36 5.93-7 3.22l5.89 32.66 3.07 31.07-5.62 26.26s-2.19 7.79 5.07 5.54 13.57-14.4 15.43-17.54l4.84-6.65-3.17-17.11z",
    fill: "url(#l)",
    style: {
      fill: "url(#l)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m109.345 265.211 17.81-9.86s5.72 4.48 7.52 1.14l2.74 33.14 5 30.79 12.22 23.68s4.11 6.89-3.45 6.77c-7.56-.12-16.78-10-19.38-12.52l-6.37-5-1.36-17.37z",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109.345 265.211 17.81-9.86s5.72 4.48 7.52 1.14l2.74 33.14 5 30.79 12.22 23.68s4.11 6.89-3.45 6.77c-7.56-.12-16.78-10-19.38-12.52l-6.37-5-1.36-17.37z",
    fill: "url(#m)",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    style: {
      fill: "url(#n)"
    },
    transform: "translate(-93.035 -1.609)",
    d: "m208.44 75.33-25.37 25.54-13.62-23.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.055 67.151c-.91-.09-2.4-2.1-3-2.77-1.92-2.29-3-5.17-4.59-7.66-7.66-11.77-13.66-10.59-20.2-13.6 2.16.36 4.33.67 6.47 1.16 7.95 1.79 12.25 6.31 18.27 10.66a11.08 11.08 0 0 1 1.59 3q1.29 3.12 2.56 6.26c.44 1.08.71 3.13-1.1 2.95z",
    fill: "url(#o)",
    style: {
      fill: "url(#o)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperMan);
export default __webpack_public_path__ + "static/media/SuperMan.2a1587442dc096ce64b93c015e267946.svg";
export { ForwardRef as ReactComponent };